import {Button, Popover} from 'antd';

import {Text} from '../../../../../../../component/text/text';
import {Locale} from '../../../../../../../provider/locale/localization';
import {CatalogPriorityPlacementEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';
import {classNames} from '../../../../../../../util/css';

import WgisPriorityPlacementMarkerGray from './images/wgis-priority-placement-gray.svg';
import WgisPriorityPlacementMarker from './images/wgis-priority-placement-marker.svg';
import {
    getDocumentationLink,
    priorityStatusMarkPopoverContentLangKey,
    priorityStatusMarkPopoverTitleLangKey,
} from './wgis-priority-placement-mark-helper';
import * as styles from './wgis-priority-placement-mark.scss';

type PropsType = {
    priorityPlacement?: CatalogPriorityPlacementEnum;
};

export function WgisPriorityPlacementMark(props: PropsType): JSX.Element | null {
    const {priorityPlacement} = props;

    // eslint-disable-next-line no-undefined
    if (priorityPlacement === null || priorityPlacement === undefined) {
        return null;
    }

    return (
        <Popover
            className={styles.WgisPriorityPlacementMark_popoverContent}
            content={
                <div className={styles.WgisPriorityPlacementMark_popoverContent}>
                    <Text block stringKey={priorityStatusMarkPopoverContentLangKey[priorityPlacement]} />
                    <Button
                        className={styles.WgisPriorityPlacementMark_popoverLink}
                        href={getDocumentationLink()}
                        target="_blank"
                        type="link"
                    >
                        <Locale stringKey="TEXT__MORE_DETAILS" />
                    </Button>
                </div>
            }
            title={
                <Text
                    block
                    bolder
                    className={styles.WgisPriorityPlacementMark_popoverTitle}
                    stringKey={priorityStatusMarkPopoverTitleLangKey[priorityPlacement]}
                />
            }
        >
            <div
                className={classNames(styles.WgisPriorityPlacementMark, {
                    [styles.WgisPriorityPlacementMark__actualized]:
                        priorityPlacement === CatalogPriorityPlacementEnum.PriorityPlacement,
                    [styles.WgisPriorityPlacementMark__notActualized]:
                        priorityPlacement === CatalogPriorityPlacementEnum.NotPriorityPlacement,
                })}
            >
                <img
                    alt="marker"
                    src={
                        priorityPlacement === CatalogPriorityPlacementEnum.PriorityPlacement
                            ? WgisPriorityPlacementMarker
                            : WgisPriorityPlacementMarkerGray
                    }
                />
            </div>
        </Popover>
    );
}
